import classNames from "classnames";
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import FilmwebSGLogoSvg from 'src/components/svg/FilmwebSGLogoSvg';
import styles from './StreamingguideLogo.module.css';

//#region [Props]
type StreamingguideLogoProps = {
	className?: string;
};
//#endregion

//#region [Component]
export default function StreamingguideLogo({ className }: StreamingguideLogoProps) {
	return <FilmwebLink to="/streamingguide" aria-label="Streamingguiden" className={classNames(styles.SLogoContainer, className)}><FilmwebSGLogoSvg /></FilmwebLink>;
}
//#endregion
